import { render, staticRenderFns } from "./IdentificationDetails.vue?vue&type=template&id=143af998"
import script from "./IdentificationDetails.vue?vue&type=script&lang=ts"
export * from "./IdentificationDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports